export default __webpack_public_path__ + "static/media/animation_500_kwdib4d4.a1ec2af0.gif";